import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { Btn } from "../../../AbstractElements";
import { useTerritoriesByEmpId, useUpdateSTP, useUpdateSTPWeek } from "../hooks/useSTP";
import PaginatedRouteDropdown from "../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getTerritoriesData } from "../../Onboarding/hooks/OnBoardingRepo";
import { getBeatsData } from "../hooks/StpRepository";
import { Spinner } from "reactstrap";

type ProductCardProps = {
  setIsModalOpen?: any;
  isModalOpen?: any;
  toggleModal?: any;
  title?: any;
  rowData?: any;
};

const STPViewEditModal: React.FC<ProductCardProps> = ({
  rowData,
  setIsModalOpen,
}) => {
  console.log("rowData in modal", rowData);
  const [selectedTerritory, setSelectedTerritory] = useState<any>(null);
  const [selectedBeat, setSelectedBeat] = useState<any>(null);
  const { mutate: updateMutate } = useUpdateSTPWeek();
  const {data:getTerritory}=useTerritoriesByEmpId({
    params:{
EmployeeId:rowData?.EmployeeId
    },
    enable:!!rowData?.EmployeeId
  })

  const formateTerritoryData=(getTerritory?.data||[]).map((item:any)=>({
    id:item.TerritoryId,
    label:item.TerritoryName
  }))



  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedBeat([]);
    setSelectedTerritory([]);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedTerritory?.id) {
      toast.warn("Please select territory.");
      return;
    }
    if (!selectedBeat?.id) {
      toast.warn("Please select beat.");
      return;
    }

    const body = {
      BeatId: Number(selectedBeat?.id) || "",
      TerritoryId: Number(selectedTerritory?.id) || "",
    };
    updateMutate(
      { id: Number(rowData?.StpWeekId), body },
      {
        onSuccess: () => {
          handleClose();
        },
      }
    );
  };
  console.log('TerrirtoryId',selectedTerritory)

  useEffect(() => {
      setSelectedTerritory(rowData?.rowData?.TerritoryId);

      setSelectedBeat({
        id:rowData?.rowData?.BeatId,
        label: rowData?.rowData?.BeatName,
      });    
  }, [rowData]);
  const isLoading=!getTerritory?.data 

  return (
    <>   
     {isLoading?(
         <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "60vh" }}
                >
                  <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
                  {/* <span className="ms-3">Loading SGPI Brands...</span> */}
                </div>
    ):(

    
    <form onSubmit={handleSubmit}>
      <div className="row mb-0">
        <RouteDropdown
        onChange={(value:any)=>{setSelectedTerritory(value);setSelectedBeat(null);}}
        value={selectedTerritory}
        DropdownHeading="Territory*"
        options={formateTerritoryData||[]}
        />

        <PaginatedRouteDropdown
        key={selectedTerritory}
          DropdownHeading="Beat*"
          placeholder="Select Beat"
          initialSelectedOptions={selectedBeat}
          onChange={(val: any) => {
            setSelectedBeat(val);
          }}
          fetchOptions={async (page: number, search: string = "") => {
            if (!selectedTerritory) return [];
            const res = await getBeatsData({
              TerritoryId: selectedTerritory,
              search,
              page,
              limit: 10,
            });

            return (
              res?.data?.data?.map((item: any) => ({
                id: item.BeatId,
                label: item.BeatName,
              })) || []
            );
        }
          }
        />
        <div style={{ height: 20 }} />
        <div className="d-flex justify-content-start gap-2">
          <Btn
            style={{ backgroundColor: "#43B9B2", color: "white" }}
            type="submit"
          >
            Update
          </Btn>
          <Btn
            style={{
              backgroundColor: "#F9FAFC",
              color: "#000",
              border: "1px solid #E0E0E0",
            }}
            type="button"
            onClick={() => {
              setIsModalOpen(false);
            }}
          >
            Cancel
          </Btn>
        </div>
      </div>
    </form>
        )
    }
    </>
  );
};

export default STPViewEditModal;
